import axios from "axios";
import { axiosDefault, axiosWAuth } from "./axios";

let config = null;

class ApiRequest {
  constructor(args) {
    const { url = "/", method = "post", payload = null, isAuth = false } = args;
    this.url = url;
    this.method = method;
    this.payload = payload;
    this.isAuth = isAuth;
  }

  run = async () => {
    if (!config) {
      config = await axios.get("./config/runtime.json").then(conf => conf.data);
    }

    if (this.isAuth) {
      return axiosWAuth(config)[this.method](
        this.url,
        this.payload && this.payload
      );
    } else {
      return axiosDefault(config)[this.method](
        this.url,
        this.payload && this.payload
      );
    }
  };
}

export const fetchFormFieldData = async (field, tab) => {
  let url = "/api/v1/" + field;
  if (tab) url = url + `?tab=${tab}`;
  const request = new ApiRequest({
    url,
    isAuth: true
  });
  const response = await request.run();
  return response.data;
};

export const deleteSavedSearch = async id => {
  const url = `/api/v1/SavedSearches/DeleteSavedSearch?id=${id}`;
  const request = new ApiRequest({
    url,
    isAuth: true
  });
  const response = await request.run();
  return response.data;
};
export const saveSearch = async payload => {
  const url = "/api/v1/SavedSearches/SaveSearch";
  const request = new ApiRequest({
    url,
    isAuth: true,
    payload: payload
  });
  const response = await request.run();
  return response.data;
};
export const updateSavedSearch = async payload => {
  const url = "/api/v1/SavedSearches/UpdateSavedSearch";
  const request = new ApiRequest({
    url,
    isAuth: true,
    payload: payload
  });
  const response = await request.run();
  return response.data;
};
export const fetchSavedSearches = async (tab) => {
  let url = "/api/v1/SavedSearches/GetSavedSearches";
  if (tab) url = url + `?tab=${tab}`;
  const request = new ApiRequest({
    url,
    isAuth: true,
    method: "get"
  });

  const response = await request.run();
  return response.data;
};
export const getAdvertisers = async payload => {
  const url = "/api/v1/Spot/AdvertiserSearch";
  const request = new ApiRequest({
    url,
    isAuth: true,
    payload: payload
  });
  const response = await request.run();
  return response.data;
};
export const getBuyingAgencies = async payload => {
  const url = "/api/v1/Spot/BuyingAgencySearch";
  const request = new ApiRequest({
    url,
    isAuth: true,
    payload: payload
  });
  const response = await request.run();
  return response.data;
};

export const getQueryCost = async payload => {
  const url = "/api/v1/QueryCost";
  const request = new ApiRequest({
    url,
    isAuth: true,
    payload: payload
  });
  const response = await request.run();
  return response.data;
};

export const getProducts = async payload => {
  const url = "/api/v1/Spot/ProductNameSearch";
  const request = new ApiRequest({
    url,
    isAuth: true,
    payload: payload
  });
  const response = await request.run();
  return response.data;
};
export const getFilmCodes = async payload => {
  const url = "/api/v1/Spot/SpotSearch";
  const request = new ApiRequest({
    url,
    isAuth: true,
    payload: payload
  });
  const response = await request.run();
  return response.data;
};
export const getProductClasses = async payload => {
  const url = "/api/v1/Spot/GetProductClasses";
  const request = new ApiRequest({
    url,
    isAuth: true,
    payload: payload
  });
  const response = await request.run();
  return response.data;
};
/*
olika kolumner tillgängliga för olika vyer
*/
export const getColumnTypes = async view => {
  const url = `/api/v1/ColumnTypes?view=${view}`;
  const request = new ApiRequest({
    url,
    isAuth: true
  });
  const response = await request.run();
  return response.data;
};
export const getMeasures = async view => {
  const url = `/api/v1/Measures?view=${view}`;
  const request = new ApiRequest({
    url,
    isAuth: true
  });
  const response = await request.run();
  return response.data;
};

export const getAllChannels = async dateQuery => {
  const url = `/api/v1/Channels/AllChannels`;
  const request = new ApiRequest({
    url,
    isAuth: true,
    payload: dateQuery
  });
  const response = await request.run();
  return response.data;
};
export const getStreamingDomainGroups = async dateQuery => {
  const url = `/api/v1/Channels/StreamingDomainGroups`;
  const request = new ApiRequest({
    url,
    isAuth: true,
    payload: dateQuery
  });
  const response = await request.run();
  return response.data;
};
export const getTimeshift = async () => {
  const url = `/api/v1/Timeshift`;
  const request = new ApiRequest({
    url,
    isAuth: true
  });
  const response = await request.run();
  return response.data;
};
export const getTimeshiftForStreaming = async () => {
  const url = `/api/v1/Timeshift?tab=streaming`;
  const request = new ApiRequest({
    url,
    isAuth: true
  });
  const response = await request.run();
  return response.data;
};

export const getGenres = async () => {
  const url = `/api/v1/Genre`;
  const request = new ApiRequest({
    url,
    isAuth: true
  });
  const response = await request.run();
  return response.data;
};

export const executeGenresQuery = async query => {
  const url = `/api/v1/QueryData`;
  const request = new ApiRequest({
    url,
    isAuth: true,
    payload: query
  });
  const response = await request.run();
  return response.data;
};
export const executeQueryDataQuery = async query => {
  const url = `/api/v1/QueryData`;
  const request = new ApiRequest({
    url,
    isAuth: true,
    payload: query
  });
  const response = await request.run();
  return response.data;
};
export const executeVideoInHomeQuery = async query => {
  const url = `/api/v1/QueryDataVideoInHome`;
  const request = new ApiRequest({
    url,
    isAuth: true,
    payload: query
  });
  const response = await request.run();
  return response.data;
};
export const executeToplistQuery = async query => {
  const url = `/api/v1/ProgramLight/Toplist`;
  const request = new ApiRequest({
    url,
    isAuth: true,
    payload: query
  });
  const response = await request.run();
  return response.data;
};

export const executeCampaignsRoFQuery = async query => {
  const url = `/api/v1/RoFSpots`;
  const request = new ApiRequest({
    url,
    isAuth: true,
    payload: query
  });
  const response = await request.run();
  return response.data;
};

export const executeProgramsRoFQuery = async query => {
  const url = `/api/v1/RoFPrograms`;
  const request = new ApiRequest({
    url,
    isAuth: true,
    payload: query
  });
  const response = await request.run();
  return response.data;
};

export const createScheduledReportQuery = async (reportname, query) => {
  const url = `/api/v1/ScheduledReport/CreateNew?scheduledReportName=${reportname}`;
  const request = new ApiRequest({
    url,
    isAuth: true,
    payload: query
  });
  const response = await request.run();
  return response.data;
};

export const executeChannelsRoFQuery = async query => {
  const url = `/api/v1/RoFChannels`;
  const request = new ApiRequest({
    url,
    isAuth: true,
    payload: query
  });
  const response = await request.run();
  return response.data;
};
export const executeStreamingRoFQuery = async query => {
  const url = `/api/v1/RoFStreaming`;
  const request = new ApiRequest({
    url,
    isAuth: true,
    payload: query
  });
  const response = await request.run();
  return response.data;
};
export const getCategories = async () => {
  const url = "/api/v1/Categories";
  const request = new ApiRequest({
    url,
    isAuth: true
  });
  const response = await request.run();
  return response.data;
};

export const executeExportQuery = async query => {
  const url = `/api/v1/Export`;
  const request = new ApiRequest({
    url,
    isAuth: true,
    payload: query
  });
  const response = await request.run();
  return response.data;
};

export const getSpottypes = async () => {
  const url = `/api/v1/Spottypes`;
  const request = new ApiRequest({
    url,
    isAuth: true
  });
  const response = await request.run();
  return response.data;
};
export const getChannelsSetup = async channelsSetup => {
  const url = `/api/v1/ChannelsSetup/GetChannelSetups`;
  const request = new ApiRequest({
    url,
    isAuth: true,
    payload: channelsSetup
  });
  const response = await request.run();
  return response.data;
};
export const createChannelsSetup = async channelsSetup => {
  const url = `/api/v1/ChannelsSetup/CreateChannelSetup`;
  const request = new ApiRequest({
    url,
    isAuth: true,
    payload: channelsSetup
  });
  const response = await request.run();
  return response.data;
};
export const editChannelsSetup = async channelsSetup => {
  const url = `/api/v1/ChannelsSetup/EditChannelSetup`;
  const request = new ApiRequest({
    url,
    isAuth: true,
    payload: channelsSetup
  });
  const response = await request.run();
  return response.data;
};
export const deleteChannelsSetup = async channelsSetup => {
  const url = `/api/v1/ChannelsSetup/DeleteChannelSetup`;
  const request = new ApiRequest({
    url,
    isAuth: true,
    payload: channelsSetup
  });
  const response = await request.run();
  return response.data;
};
